import { Card } from '../../../../../../components/card/card';
import { LangInput } from '../../../../../../features/lang-input/lang-input';
import { LangSelect } from '../../../../../../features/lang-select/lang-select';
import { useLang } from '../../../../../../hooks/use-lang';
import { useTreeStore } from '../../../../../../store/use-tree-store';
import s from './tree-name.module.css';

export const TreeName = () => {
  const { t } = useLang();
  const { tree, handleUpdateTree } = useTreeStore();

  return (
    <Card className={s.feature}>
      <div className={s.title}>
        <h3>1. {t('Название дерева')} </h3>
        <LangSelect data-testid="lang-select" />
      </div>

      <div className={s.inputs}>
        <LangInput
          placeholder={t('Название')}
          value={tree?.name}
          onChange={(e) => handleUpdateTree({ name: e })}
          data-testid="tree-name"
        />
        <LangInput
          placeholder={t('Описание')}
          value={tree?.description}
          onChange={(e) => handleUpdateTree({ description: e })}
          data-testid="tree-description"
        />
      </div>
    </Card>
  );
};
